/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Personal_Info_Upload_TitleInputs */

const en_register_onboarding_personal_info_upload_title = /** @type {(inputs: Register_Onboarding_Personal_Info_Upload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Would you like to read your CV with AI? `)
};

const de_register_onboarding_personal_info_upload_title = /** @type {(inputs: Register_Onboarding_Personal_Info_Upload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchtest du deinen Lebenslauf mit KI auslesen?`)
};

/**
* | output |
* | --- |
* | "Would you like to read your CV with AI?" |
*
* @param {Register_Onboarding_Personal_Info_Upload_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_personal_info_upload_title = /** @type {((inputs?: Register_Onboarding_Personal_Info_Upload_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Personal_Info_Upload_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_personal_info_upload_title(inputs)
	return en_register_onboarding_personal_info_upload_title(inputs)
});